import styled from "styled-components";
import { Link } from 'react-router-dom'

export const FooterContainer = styled.footer`
    background-color:#111221;
    border-top: 1px solid #e8175d;
    
`;

export const FooterWrap = styled.div`
    padding: 48px 24px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    max-width:1100px;
    margin: 0 auto;
`;
export const FooterLinksContainer = styled.div`
    display:flex;
    justify-content:center;
    @media screen and (max-width:820px){
        padding-top:32px
    }
`;
export const FooterLinksWrapper = styled.div`
    display:flex;
    @media screen and (max-width:820px){
        flex-direction:column;
    }
`;
export const FooterLinkItems = styled.div`
    display:flex;
    flex-direction:column;
    margin:16px;
    text-align:center;
    width:160px;
    box-sizing: boder-box;
    color:#fff;

    @media screen and (max-width:420px){
        margin:0;
        padding: 10px;
        width:100%
    }
`;
export const FooterLinkTitle = styled.p`
    font-size:1.2rem;
    margin-bottom:16px;
    color:#fff;
    font-weight:inherit !important;
    @media screen and (max-width:600px){
        margin-bottom:-1rem;
    }
`;
export const FooterLink = styled(Link)`
    text-decoration:none;
    background:#E8175D;
    padding:0.5rem;
    white-space:nowrap;
    color:#fff;
    font-size:1rem;
    outline:none;
    border:none;
    cursor:pointer;
    display:flex;
    justify-content:center;
    align-items:center;
    transition:all 0.2s ease-in-out;
    border-radius:10px;
    text-align:center;
    @media screen and (max-width:600px){
        width: 10rem;
    }
`;
export const FooterHead = styled.h2`
    text-align:center;
    color:#fff;
    font-size:1.5rem;
    margin-bottom:1rem;
    font-weight:400;
`;
export const SocialMedia = styled.section`
    max-width:1000px;
    width:100%;

`;
export const SocialMediaWrap = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    max-width:1100px;
    margin:40px auto 0 auto;

    @media screen and (max-width:820px){
        flex-direction:column;
    }
`;
export const SocialLogo = styled(Link)`
    color:#fff;
    justify-self:start;
    cursor:pointer;
    text-decoration:none;
    font-size:0.8rem;
    display:flex;
    align-items:center;
    font-weight:bold;
    margin-top:2rem;
    margin-bottom:-2rem;
`;
export const WebsiteRights = styled.small`
    color:#fff;
`;
export const SocialIcons = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    width:100%;
`;
export const SocialIconLink = styled.a`
    color:#fff;
    font-size:24px;
`;
export const FooterCV = styled.a`
    text-decoration:none;
    background:#E8175D;
    padding:0.5rem;
    white-space:nowrap;
    color:#fff;
    font-size:1rem;
    outline:none;
    border:none;
    cursor:pointer;
    display:flex;
    justify-content:center;
    align-items:center;
    transition:all 0.2s ease-in-out;
    border-radius:10px;
    @media screen and (max-width:600px){
        width: 10rem;
    }
`; 
export const FooterCopy = styled.div`
    background:#000014;
    text-align:center;
    padding:1rem;
`;
export const JimyyRamz = styled.a`
    color:#fff;
    font-style:italic;
`;